import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appVirtualKeyboard]'
})
export class VirtualKeyboardDirective {
  @Input() appVirtualKeyboard: string[] = [];

  constructor(private ngControl: NgControl) {}

  @HostListener('click', ['$event.target']) onClick(target: HTMLElement) {
    const key = target.innerText;
    if (!this.ngControl.control || !key) return;

    let currentValue = this.ngControl.control.value || '';
    if (key === '←') {
      this.ngControl.control.setValue(currentValue.slice(0, -1));
    } else if (key === 'Space') {
      this.ngControl.control.setValue(currentValue + ' ');
    } else {
      this.ngControl.control.setValue(currentValue + key);
    }
  }
}
